/* Native dialog supplies keyboard containment, Escape dismissal and modal semantics. */
(() => {
  function initialize() {
    const dialog = document.getElementById('NookMenu');
    const trigger = document.querySelector('[data-menu-open]');
    if (!dialog || !trigger || typeof dialog.showModal !== 'function') return;
    document.documentElement.classList.add('nook-js');
    trigger.hidden = false;
    if (dialog.dataset.initialized) return;
    dialog.dataset.initialized = 'true';
    function close() { dialog.close(); }
    trigger.addEventListener('click', () => {
      if (!dialog.open) dialog.showModal();
      trigger.setAttribute('aria-expanded', 'true');
    });
    dialog.querySelector('[data-menu-close]').addEventListener('click', close);
    dialog.addEventListener('close', () => {
      trigger.setAttribute('aria-expanded', 'false');
      const focusTarget = window.matchMedia('(min-width: 990px)').matches
        ? document.querySelector('.nook-header .nook-wordmark')
        : trigger;
      focusTarget?.focus({ preventScroll: true });
    });
    dialog.addEventListener('click', (event) => {
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
    });
    dialog.querySelectorAll('a').forEach(link => link.addEventListener('click', close));
    const desktop = window.matchMedia('(min-width: 990px)');
    desktop.addEventListener('change', () => { if (desktop.matches && dialog.open) close(); });
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:block:select', initialize);
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.nook-nav-dropdown[open]').forEach(dropdown => {
      dropdown.open = false;
      dropdown.querySelector('summary').focus();
    });
  });
})();
